import React from 'react';

function SlideThumbnailCompactRow(props) {
  //console.log("desktopMode = " + props.desktopMode);
  let num = 0;
  if (props.images) {
    num += props.images.length;
  }

  if (props.videos) {
    num += props.videos.length;
  }

  return (
    <div className="riga-thumbnails-compact">
      <div className="contenitore-thumbnails-compact">
        <div
          className="freccia-th-or-sx"
          onClick={(e) => props.clickHandler(e, props.currentIdx === 0? num-1 : props.currentIdx -1)}
        >
          &lt;
        </div>
        <p className="th-or-compact">
          {props.currentIdx + 1} / {num}
        </p>
        <div
          className="freccia-th-or-dx"
          onClick={(e) => props.clickHandler(e, props.currentIdx === (num-1)? 0 : props.currentIdx + 1)}
        >
          &gt;
        </div>
      </div>
    </div>
  );
}

export default SlideThumbnailCompactRow;